// Deeplinks naar de Bouwflow web-app (SPEC 27okt 5). Eén bron van waarheid voor server en browser.
//
// Diagnose 27 okt 2026: de link ging naar renotex.bouwflow.be, het oude domein. Bouwflow draait nu
// op recotex.bouwflow.be; beide domeinen antwoorden, maar een Bouwflow-sessie geldt per domein. Wie
// op het nieuwe domein ingelogd is, kwam via de link op het inlogscherm van het oude domein (en na
// inloggen niet op het project): "soms wel, soms niet", afhankelijk van de browser, niet van het
// project. Het pad gebruikt de tenant-slug van het Bouwflow-team, die nog altijd "renotex" is.
//
// Een project wordt geopend op zijn interne Bouwflow-id (niet op de P-code). Geen geldige id → geen
// link maar een grijs icoon met tooltip "geen Bouwflow-koppeling" (geen dode links).

/** Basis-URL van de Bouwflow web-app (zonder /public-api). */
export const BOUWFLOW_WEB_BASE = 'https://recotex.bouwflow.be';

/** Tenant-slug van het Bouwflow-team (team.slug in de API). */
export const BOUWFLOW_TEAM_SLUG = 'renotex';

/** Geldige interne Bouwflow-id: positief geheel getal. */
export function isGeldigeBouwflowId(id: unknown): id is number {
  return typeof id === 'number' && Number.isInteger(id) && id > 0;
}

/** Deeplink naar een project in Bouwflow, of null zonder geldige interne id. */
export function bouwflowProjectUrl(bouwflowProjectId: number | null | undefined): string | null {
  if (!isGeldigeBouwflowId(bouwflowProjectId)) return null;
  return `${BOUWFLOW_WEB_BASE}/app/${BOUWFLOW_TEAM_SLUG}/projects/${bouwflowProjectId}`;
}

export const GEEN_BOUWFLOW_KOPPELING = 'geen Bouwflow-koppeling';
